import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import AddressPicker from "./AddressPicker";
const Address = ({ partner, children }) => {
    const [showAddressModal, setShowAddressModal] = useState(false);
    return (_jsx(AddressPicker, { showAddressModal: showAddressModal, setShowAddressModal: setShowAddressModal, close: () => setShowAddressModal(false), name: "destination_address", partner: partner, children: children }));
};
export default Address;
